import Error from '../../model/Error';
import axios from 'axios';

export default class ClubExamPartRepository {
    static update(clubExamId, clubExamParts) {
        const data = { clubExamParts: clubExamParts.map((clubExamPart) => clubExamPart.serialize()) };
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/exams/${clubExamId}/parts`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(examPartId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/exams/parts/${examPartId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(examPartId, archived) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/exams/parts/${examPartId}/archived`, { archived })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
